import { zSidLabel } from "src/types";
import z from "zod";

import { zSysDataHistory } from "../sysData/ZSysData";
import { zWorkflowDestination } from "./ZWorkflow";

export const zWorkflowStream = zSysDataHistory.extend({
  id: z.string(),
  displayId: z.number(),
  name: z.string(),
  displayName: z.string().nullish(),
  description: z.string().nullish(),
  destination: zWorkflowDestination.nullish(),
  catalog: zSidLabel.nullish(),
  owner: zSidLabel.nullish(),
});

export type ZWorkflowStream = z.infer<typeof zWorkflowStream>;
export type WorkflowStreamsFilter = {};
